import { useOktaAuth } from "@okta/okta-react";
import { useEffect, useState } from 'react';
import { getRequestsInGroup } from "../../services/cm.service";
import { SupplierGroup } from "../conflict-mineral/SupplierInGroupList";

export const SuppliersTable = ({ campaign, suppliers,updateSuppliersArray }) => {
    const { authState } = useOktaAuth();
    const campaignId = campaign ? campaign.id : '';
    const supplierNum = campaign && Array.isArray(campaign.assignments) && campaign.assignments.length > 0 ? campaign.assignments[0].supplierNumber : '';
    const [suppliersInGroup, setSuppliersInGroup] = useState([]);
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);

    useEffect(() => {
        if (suppliers) {
          setSelectedSuppliers([...suppliers]);
        }
    }, [suppliers]);

    const getSelectedData=(items)=>{
        const data=[];
        items.forEach(i=>{
            data.push(suppliersInGroup.filter(item=>item.supplierNumber===i)[0]);
        })
        return data;
    }

    useEffect(() => {
        if (campaignId && supplierNum) {
            getRequestsInGroup(supplierNum, campaignId, authState.accessToken.accessToken).then(response => {
                if (Array.isArray(response) && response.length > 0) {
                    setSuppliersInGroup(response);
                }
                else {
                    if (campaign && Array.isArray(campaign.assignments) && campaign.assignments.length > 0) {
                        const onlySupplierName = campaign.assignments[0].supplierName ? campaign.assignments[0].supplierName.split('-') : [];
                        const responseObj = 
                            { id: campaign.assignments[0].id, 
                              status : campaign.assignments[0].status, 
                              supplierNumber: campaign.assignments[0].supplierNumber, 
                              groupNumber: null, 
                              supplierName: onlySupplierName.length == 2 ? onlySupplierName[1] :  campaign.assignments[0].supplierNumber
                            }
                        setSuppliersInGroup([responseObj]);      
                }
            }
            })
}
    }, [authState.accessToken.accessToken, campaignId, selectedSuppliers, supplierNum]);

const onCheck = (event) => {
    let aux = [...selectedSuppliers];
    if (event.target.checked) {
        aux.push(event.target.defaultValue);
        setSelectedSuppliers([...aux]);
        updateSuppliersArray(getSelectedData([...aux]))
    } else {
        setSelectedSuppliers(aux.filter(it => it !== event.target.defaultValue));
        updateSuppliersArray(getSelectedData(aux.filter(it => it !== event.target.defaultValue)))
    }
}

const onCheckAll = (event) => {
    let aux = [];
    if (event.target.checked) {
        for (let it of suppliersInGroup) {
            if (!it.groupNumber) {
                aux.push(it.supplierNumber);
            }
        }
    }
    setSelectedSuppliers([...aux]);
    updateSuppliersArray(getSelectedData([...aux]))
}


return <SupplierGroup list={suppliersInGroup} onCheck={onCheck} onCheckAll={onCheckAll} selectedSuppliers={selectedSuppliers && selectedSuppliers.length > 0 ? selectedSuppliers : suppliers} campaign={campaign}/>;
}
